import React, { useEffect, useState } from "react";
import "./Banner.css";
import api from "../Services/api";
const HomeBanner = () => {
  const [banners, setBanner] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const buildImageUrl = (url: string) => {
    if (!url) return "";
    if (url.startsWith('http')) return url;
    if (url.startsWith('/')) {
      return `https://institucional.forluz.org.br${url}`;
    }
    return url;
  };

  useEffect(() => {
    api
      .get("/ObterBanners")
      .then((response) => {
        const apiBanners = response.data.results || [];

        const activeBanners = apiBanners.filter((banner: any) => {
          if (!banner.Ativo) return false;

          const now = new Date();
          const startDate = banner.Inicio_x0020_Campanha
            ? new Date(banner.Inicio_x0020_Campanha)
            : null;
          const endDate = banner.Fim_x0020_Campanha
            ? new Date(banner.Fim_x0020_Campanha)
            : null;

          if (startDate && now < startDate) return false;
          if (endDate && now > endDate) return false;

          return true;
        });

        const processedBanners = activeBanners.map((banner: any) => {
          const processedUrl = buildImageUrl(banner.URL);
          return {
            ...banner,
            URL: processedUrl
          };
        });

        setBanner(processedBanners);
      })
      .catch((err) => {
        console.error("Erro ao carregar banners:", err);

      });
  }, []);

  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  const handlePrevClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (banners.length > 1) {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? banners.length - 1 : prevIndex - 1
      );
    }
  };

  const handleNextClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (banners.length > 1) {
      setCurrentIndex((prevIndex) =>
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  if (!banners || banners.length === 0) {
    return null;
  }

  const currentBanner = banners[currentIndex];

  if (!currentBanner) {
    return null;
  }

  return (
    <section className="banner-container">
      <div className="banner-content">
        <div className="banner-single">
          <div className="banner-item">
            {currentBanner?.URL ? (
              <a
                href={currentBanner.Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="banner-image-wrapper">
                  <img
                    src={currentBanner?.URL}
                    alt={currentBanner?.Title || `Banner ${currentIndex + 1}`}
                    className="banner-background-image"
                  />
                </div>
                <div className="banner-overlay-text">
                  <h1 className="banner-title">
                    {currentBanner?.Title}
                  </h1>
                  {currentBanner?.Descricao && (
                    <p className="banner-description">
                      {currentBanner?.Descricao}
                    </p>
                  )}
                </div>
              </a>
            ) : (
              <div>
                <div className="banner-image-wrapper">
                  <img
                    src={currentBanner?.URL}
                    alt={currentBanner?.Title || `Banner ${currentIndex + 1}`}
                    className="banner-background-image"
                  />
                </div>
                <div className="banner-overlay-text">
                  <h1 className="banner-title">
                    {currentBanner?.Title}
                  </h1>
                  {currentBanner?.Descricao && (
                    <p className="banner-description">
                      {currentBanner?.Descricao}
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* Setas de navegação */}
            <div
              className={`banner-navigation ${banners.length <= 1 ? "disabled" : ""}`}
            >
              <button
                className="banner-nav-btn banner-prev"
                onClick={handlePrevClick}
                aria-label="Banner anterior"
                type="button"
                disabled={banners.length <= 1}
              >
                ←
              </button>
              <button
                className="banner-nav-btn banner-next"
                onClick={handleNextClick}
                aria-label="Próximo banner"
                type="button"
                disabled={banners.length <= 1}
              >
                →
              </button>
            </div>

            {/* Indicadores de posição */}
            <div className="banner-indicators">
              {banners.map((_, index) => (
                <button
                  key={index}
                  className={`banner-indicator ${index === currentIndex ? "active" : ""}`}
                  onClick={() => setCurrentIndex(index)}
                  aria-label={`Ir para banner ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;